export * from './baPageTop.component';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baPageTop/index.ts